var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useEffect, useImperativeHandle, useRef, } from "react";
import { useIntl } from "react-intl";
import { Selection } from "@folio/stripes/components";
import { HelpTooltip } from "./HelpTooltip";
import styles from "./RecekInput.module.css";
import { useHelpTooltip } from "../../hooks/useHelpTooltip";
export var RecekSelection = forwardRef(function (_a, ref) {
    var labelId = _a.labelId, _b = _a.showLabel, showLabel = _b === void 0 ? true : _b, initialFilterValue = _a.initialFilterValue, rest = __rest(_a, ["labelId", "showLabel", "initialFilterValue"]);
    var formatMessage = useIntl().formatMessage;
    var _c = useHelpTooltip(labelId), helpId = _c.helpId, hasHelp = _c.hasHelp;
    var wrapperRef = useRef(null);
    var filterInitialized = useRef(false);
    useImperativeHandle(ref, function () { return ({
        focus: function () {
            var _a;
            var input = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("input, button");
            input === null || input === void 0 ? void 0 : input.focus();
        },
    }); });
    useEffect(function () {
        if (!initialFilterValue || filterInitialized.current)
            return undefined;
        var setFilterTimer = setTimeout(function () {
            var _a, _b;
            var filterInput = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("input");
            if (!filterInput)
                return;
            var nativeSetter = (_b = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value")) === null || _b === void 0 ? void 0 : _b.set;
            if (!nativeSetter)
                return;
            var tracker = filterInput
                ._valueTracker;
            tracker === null || tracker === void 0 ? void 0 : tracker.setValue("");
            nativeSetter.call(filterInput, initialFilterValue);
            filterInput.dispatchEvent(new Event("input", { bubbles: true }));
            filterInitialized.current = true;
        }, 0);
        var openTimer = setTimeout(function () {
            var _a;
            var toggleButton = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("button");
            toggleButton === null || toggleButton === void 0 ? void 0 : toggleButton.click();
        }, 300);
        return function () {
            clearTimeout(setFilterTimer);
            clearTimeout(openTimer);
        };
    }, [initialFilterValue]);
    return (React.createElement("div", { ref: wrapperRef, className: styles.wrapper },
        React.createElement(Selection, __assign({}, rest, { label: showLabel ? formatMessage({ id: labelId }) : undefined })),
        hasHelp && (React.createElement(HelpTooltip, { id: "".concat(labelId, "-help"), textId: helpId, hasLabel: showLabel }))));
});
